const colors: { [key: string]: { [key: string]: string } } = {
  radio: {
    primary: 'radio-primary',
    secondary: 'radio-secondary',
    accent: 'radio-accent',
    neutral: 'radio-neutral',
    info: 'radio-info',
    success: 'radio-success',
    warning: 'radio-warning',
    error: 'radio-error'
  },
  btn: {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    accent: 'btn-accent',
    neutral: 'btn-neutral',
    info: 'btn-info',
    success: 'btn-success',
    warning: 'btn-warning',
    error: 'btn-error'
  },
  input: {
    primary: 'input-primary',
    secondary: 'input-secondary',
    accent: 'input-accent',
    neutral: 'input-neutral',
    info: 'input-info',
    success: 'input-success',
    warning: 'input-warning',
    error: 'input-error'
  },
  textarea: {
    primary: 'textarea-primary',
    secondary: 'textarea-secondary',
    accent: 'textarea-accent',
    neutral: 'textarea-neutral',
    info: 'textarea-info',
    success: 'textarea-success',
    warning: 'textarea-warning',
    error: 'textarea-error'
  },
  datepicker: {
    primary: 'datepicker-primary',
    secondary: 'datepicker-secondary',
    accent: 'datepicker-accent',
    neutral: 'datepicker-neutral',
    info: 'datepicker-info',
    success: 'datepicker-success',
    warning: 'datepicker-warning',
    error: 'datepicker-error'
  },
  select: {
    primary: 'select-primary',
    secondary: 'select-secondary',
    accent: 'select-accent',
    neutral: 'select-neutral',
    info: 'select-info',
    success: 'select-success',
    warning: 'select-warning',
    error: 'select-error'
  },
  toggle: {
    primary: 'toggle-primary',
    secondary: 'toggle-secondary',
    accent: 'toggle-accent',
    neutral: 'toggle-neutral',
    info: 'toggle-info',
    success: 'toggle-success',
    warning: 'toggle-warning',
    error: 'toggle-error'
  },
  checkbox: {
    primary: 'checkbox-primary',
    secondary: 'checkbox-secondary',
    accent: 'checkbox-accent',
    neutral: 'checkbox-neutral',
    info: 'checkbox-info',
    success: 'checkbox-success',
    warning: 'checkbox-warning',
    error: 'checkbox-error'
  }
}
const sizes: { [key: string]: { [key: string]: string } } = {
  radio: {
    large: 'radio-lg',
    normal: 'radio-md',
    small: 'radio-sm',
    mini: 'radio-xs'
  },
  btn: {
    large: 'btn-lg',
    normal: 'btn-md',
    small: 'btn-sm',
    mini: 'btn-xs'
  },
  input: {
    large: 'input-lg',
    normal: 'input-md',
    small: 'input-sm',
    mini: 'input-xs'
  },
  textarea: {
    large: 'textarea-lg',
    normal: 'textarea-md',
    small: 'textarea-sm',
    mini: 'textarea-xs'
  },
  datepicker: {
    large: 'datepicker-lg',
    normal: 'datepicker-md',
    small: 'datepicker-sm',
    mini: 'datepicker-xs'
  },
  select: {
    large: 'select-lg',
    normal: 'select-md',
    small: 'select-sm',
    mini: 'select-xs'
  },
  toggle: {
    large: 'toggle-lg',
    normal: 'toggle-md',
    small: 'toggle-sm',
    mini: 'toggle-xs'
  },
  checkbox: {
    large: 'checkbox-lg',
    normal: 'checkbox-md',
    small: 'checkbox-sm',
    mini: 'checkbox-xs'
  }
}
export const daisyuiColor = (prefix: string, color: string | undefined) => {
  if (!color) {
    return {}
  }
  if (!colors[prefix]) {
    return {}
  }
  if (!colors[prefix][color]) {
    return {}
  }
  return { [colors[prefix][color]]: true }
}
export const daisyuiSize = (prefix: string, size: string | undefined) => {
  if (!size) {
    return {}
  }
  if (!sizes[prefix]) {
    return {}
  }
  if (!sizes[prefix][size]) {
    return {}
  }
  return { [sizes[prefix][size]]: true }
}

export const daisyuiColorSize = (prefix: string, props: any) => {
  const { color, size } = toRefs(props)
  return { ...daisyuiColor(prefix, color?.value), ...daisyuiSize(prefix, size?.value) }
}
